import React from 'react'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { useIsDarkMode } from '@/contexts/ThemeContext'

interface Props {
  src: string
  alt: string
}

export const ResponsiveSearchImage: React.FC<Props> = ({ src, alt }) => {
  const isDarkMode = useIsDarkMode()

  const sharedDivClasses = classNames(
    'flex shrink-0 items-center justify-center rounded-lg',
    isDarkMode ? 'bg-transparent' : 'bg-core-gray-950 p-1',
  )

  const sharedImgClasses = 'h-full w-full rounded-lg object-contain'

  return (
    <>
      {/* 9:16 aspect ratio */}
      <div className={classNames(sharedDivClasses, 'h-[45px] w-[80px] sm:hidden')}>
        <Image className={sharedImgClasses} src={src} alt={alt} height={45} width={80} />
      </div>
      <div className={classNames(sharedDivClasses, 'hidden h-[54px] w-[96px] sm:block md:hidden')}>
        <Image className={sharedImgClasses} src={src} alt={alt} height={54} width={96} />
      </div>
      <div className={classNames(sharedDivClasses, 'hidden h-[72px] w-[128px] md:block')}>
        <Image className={sharedImgClasses} src={src} alt={alt} height={72} width={128} />
      </div>
    </>
  )
}
